/**
 * Generate a URL-friendly slug from a human-readable string.
 *
 * Aliases: slugify, generate slug, url slug, kebab-case
 */
export function generateSlug(value: string): string {
  return value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
}
